import { Component, inject } from '@angular/core';
import { UpdateService } from '../../services/update-service';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-update-bar',
    imports: [CommonModule],
    templateUrl: './update-bar.html',
    styleUrl: './update-bar.scss'
})
export class UpdateBar {
    protected updateService = inject(UpdateService);
}
